/*=============================================== Search styles ===============================================*/

import styled from "styled-components/macro"
import {
    Mixins,
    FontSizes,
    FontWeights,
    FontFamilies,
    Spacers,
    Radiuses,
    Shadows,
} from "tsx-library-julseb"

export const StyledSearch = styled.form`
    background-color: ${({ theme }) => theme.Background};
    padding: ${Spacers.M};
    width: 90%;
    max-width: calc(400px + ${Spacers.M} * 2);
    border-radius: ${Radiuses.M};
    box-shadow: ${Shadows.S};
    ${Mixins.Flexbox({
        $flexDirection: "column",
        $alignItems: "stretch",
        $gap: "m",
    })}
`

const BUTTON_HEIGHT = 32

export const OpenSearch = styled.button`
    width: 250px;
    height: ${BUTTON_HEIGHT}px;
    border: 1px solid ${({ theme }) => theme.Gray200};
    text-align: left;
    font-size: ${FontSizes.Body};
    font-family: ${FontFamilies.Body};
    font-weight: ${FontWeights.Regular};
    padding: 0 ${Spacers.XS};
    background-color: ${({ theme }) => theme.Background};
    border-radius: ${Radiuses.S};
    color: ${({ theme }) => theme.Gray400};
    ${Mixins.Flexbox({
        $alignItems: "center",
        $justifyContent: "flex-start",
        $gap: "xxs",
    })}
`

export const IconContainer = styled.span`
    width: 16px;
    height: ${BUTTON_HEIGHT}px;
    color: ${({ theme }) => theme.Primary500};
    ${Mixins.Flexbox({
        $alignItems: "center",
        $justifyContent: "center",
    })}
`

export const SearchPlaceholder = styled.span`
    flex-grow: 1;
`
